// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader-module__loader--2hzyI","circular":"loader-module__circular--2mvwY","path":"loader-module__path--3wSqO"};